import { render, staticRenderFns } from "./ModalKasKecilCatatan.vue?vue&type=template&id=ddc04458&scoped=true&"
import script from "./ModalKasKecilCatatan.vue?vue&type=script&lang=js&"
export * from "./ModalKasKecilCatatan.vue?vue&type=script&lang=js&"
import style0 from "./ModalKasKecilCatatan.vue?vue&type=style&index=0&id=ddc04458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc04458",
  null
  
)

export default component.exports